export default __webpack_public_path__ + "static/media/alliancedex.22895caf.svg";